import {

  AI_CHAT_ENDPOINT,

  AI_EXTRACT_DOCUMENT_ENDPOINT,

  AI_TRANSCRIBE_ENDPOINT,

  AI_VECTORIZE_SYNC_ENDPOINT,

} from '../config/agentConfig';

import i18n from '../../i18n';



const cc = (key, opts) => i18n.t(`modules.shared.aiAgent.cloudClient.${key}`, opts);



const serverError = (status, detail) => (

  detail

    ? cc('server_returned_detail', { status, detail })

    : cc('server_returned_status', { status })

);



export async function sendAgentChatRequest({ message, companyId, licenseKey, moduleId, context }) {

  const response = await fetch(AI_CHAT_ENDPOINT, {

    method: 'POST',

    headers: { 'Content-Type': 'application/json' },

    body: JSON.stringify({

      message,

      company_id: companyId,

      license_key: licenseKey,

      module_id: moduleId,

      context,

    }),

  });



  if (!response.ok) {

    let detail = '';

    try {

      const errBody = await response.json();

      detail = errBody.details || errBody.error || '';

    } catch {

      try {

        detail = await response.text();

      } catch {

        detail = '';

      }

    }

    throw new Error(serverError(response.status, detail));

  }



  const data = await response.json();

  if (!data.success) {

    throw new Error(data.error || cc('ai_request_failed'));

  }



  return data;

}



export async function sendAgentDocumentExtractionRequest({

  base64Image,

  imageMime = 'image/jpeg',

  documentType,

  userPrompt,

  companyId,

  licenseKey,

}) {

  const response = await fetch(AI_EXTRACT_DOCUMENT_ENDPOINT, {

    method: 'POST',

    headers: { 'Content-Type': 'application/json' },

    body: JSON.stringify({

      image: base64Image,

      imageMime,

      documentType,

      userPrompt,

      company_id: companyId,

      license_key: licenseKey,

    }),

  });



  if (!response.ok) {

    const errorText = await response.text();

    throw new Error(serverError(response.status, errorText));

  }



  const data = await response.json();

  if (!data.success) {

    throw new Error(data.error || cc('document_extraction_failed'));

  }



  return data;

}



export async function sendAgentTranscriptionRequest({

  audio,

  language = 'fr',

  companyId,

  licenseKey,

}) {

  const response = await fetch(AI_TRANSCRIBE_ENDPOINT, {

    method: 'POST',

    headers: { 'Content-Type': 'application/json' },

    body: JSON.stringify({

      audio,

      language,

      company_id: companyId,

      license_key: licenseKey,

    }),

  });



  if (!response.ok) {

    let detail = '';

    try {

      const errBody = await response.json();

      detail = errBody.details || errBody.error || '';

    } catch {

      try {

        detail = await response.text();

      } catch {

        detail = '';

      }

    }

    throw new Error(serverError(response.status, detail));

  }



  const data = await response.json();

  if (!data.success) {

    throw new Error(data.error || cc('transcription_failed'));

  }



  return data;

}



export async function sendAgentVectorizeSyncRequest({

  companyId,

  licenseKey,

  records,

}) {

  const response = await fetch(AI_VECTORIZE_SYNC_ENDPOINT, {

    method: 'POST',

    headers: { 'Content-Type': 'application/json' },

    body: JSON.stringify({

      company_id: companyId,

      license_key: licenseKey,

      records,

    }),

  });



  if (!response.ok) {

    let detail = '';

    try {

      const errBody = await response.json();

      detail = errBody.details || errBody.error || '';

    } catch {

      try {

        detail = await response.text();

      } catch {

        detail = '';

      }

    }

    throw new Error(

      detail

        ? cc('vectorize_sync_detail', { status: response.status, detail })

        : cc('vectorize_sync_status', { status: response.status })

    );

  }



  const data = await response.json();

  if (!data.success) {

    throw new Error(data.error || cc('vectorize_sync_failed'));

  }



  return data;

}

